module.exports = __webpack_public_path__ + "img/ariya.b3cbf95d.png";